module.exports = {"tagline":"Public campaign against construction of the E40 waterway, which threatens the valuable natural areas of Poland, Belarus and Ukraine","title":"#STOP_E40"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/hero-unit.en.json
// module id = 164
// module chunks = 0